import { hcpAPI } from 'configs/axios';

export const getEdf = (id: string, signal?: AbortSignal) => {
  return hcpAPI({ url: `/edf_exports?recording_id=${id}`, method: 'GET', config: { signal } });
};
